import { render, staticRenderFns } from "./cartItemsModal.vue?vue&type=template&id=4c909add&"
import script from "./cartItemsModal.vue?vue&type=script&lang=js&"
export * from "./cartItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports